// extracted by css-extract-rspack-plugin
export default {"Box":"TimelineRowBorder-module__Box__rci2X"};